import React from 'react';

import styled, {css} from 'styled-components';

import BaseButton from '../Button';
import {TInputProps as TMixinsInputProps, mixins} from '../styles';

export const TextInput = styled.div`
  position: relative;
`;

type TInputProps = React.InputHTMLAttributes<HTMLInputElement> & TMixinsInputProps;

export const Input = styled.input<TInputProps>`
  ${mixins.input}
  ${({theme}) => css`
    ${mixins.getFont(theme.typography.input)}
    line-height: ${theme.dimensions.controlHeightM}px;
  `};
`;

export const Icon = styled.svg`
  ${mixins.wh('16px')}
`;

export const Button = styled(BaseButton).attrs({square: true})`
  background: none;
  border: none;
  box-shadow: none;
`;

export const ArrowInputContainer = styled.div`
  position: relative;
`;

export const ArrowInput = styled(Input)`
  padding-right: 36px;

  /* stylelint-disable property-no-vendor-prefix */
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
  /* stylelint-enable property-no-vendor-prefix */
`;

export const ArrowsContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  user-select: none;
`;

export const ArrowDown = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 12px;
  height: 12px;
  overflow: hidden;

  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;

  cursor: pointer;

  ${({theme}) => css`
    background: ${theme.palette.white};

    &:hover {
      color: ${theme.branding.content.secondary};
    }
  `};
`;

export const ArrowUp = styled(ArrowDown)`
  transform: rotate(180deg);
`;
